import {useParams} from 'react-router';
import {useQuery} from '@apollo/client';
import {Empty, Spin} from 'antd';
import _ from 'lodash';

import {CollectionSelect} from '../../../components/CollectionSelect/CollectionSelect';
import {collection, collectionVariables} from '../../../shared/graphql/__generated__/collection';
import {positions, positionsVariables} from '../../../shared/graphql/__generated__/positions';
import {QUERY_COLLECTION} from '../../../shared/graphql/collection';
import {QUERY_POSITIONS} from '../../../shared/graphql/position';

import {Card} from './Card';

import cls from './Category.module.scss'

export const Collection = () => {

    const {id} = useParams()
    
    const query = useQuery<collection,collectionVariables>(QUERY_COLLECTION, {
        variables: {
            documentId: id!
        }
    })

    const positions = useQuery<positions,positionsVariables>(QUERY_POSITIONS, {
        variables: {
            filters: {
                // category: {eq: id},
                collections: id ? {documentId: {eq: id}} : undefined,
            },
            sort: ['createdAt:DESC'],
            pagination: {
                limit: 100,
            }
        }
    })

    return (
        <div className={cls.page}>

            <h1>{query.data?.collection?.name}</h1>

            <CollectionSelect/>

            {positions.loading && <Spin/>}
            {positions.data?.positions.length === 0 && <Empty/>}
            <div className={cls.table}>
                {_.map(positions.data?.positions, item => (
                    <Card key={item?.documentId} id={item?.documentId!} name={item?.name!} price={item?.price!} tag_hit={item?.hit!} tag_new={item?.new!} tag_pre_order={item?.pre_order!} cover={item?.cover.url!} aromas={item?.aromas ?? undefined} />
                ))}
            </div>

        </div>
    )
}